import {
  DeviceGroupModel,
  DeviceGroupPlaylistModel
} from '@models/digital-signage/device-groups.model.ts';

/** UI week day index, Monday first */
export enum WeekDayEnum {
  Mon = 0,
  Tue = 1,
  Wed = 2,
  Thu = 3,
  Fri = 4,
  Sat = 5,
  Sun = 6
}

/** Week day as the API sends and expects it */
export type ScheduleWeekDayApi =
  | 'mon'
  | 'tue'
  | 'wed'
  | 'thu'
  | 'fri'
  | 'sat'
  | 'sun';

export interface PlaylistScheduleSlotModel {
  _id?: string;
  daysOfWeek: ScheduleWeekDayApi[];
  /** 'HH:mm' */
  startTime: string;
  /** 'HH:mm', '00:00' means the end of the day */
  endTime: string;
  /** Playlist ids, sent by older schedules instead of the top-level playlist */
  playlists?: string[];
}

export interface DeviceGroupScheduleModel {
  _id: string;
  name: string;
  orgId?: number;
  playlist?: DeviceGroupPlaylistModel | string | null;
  deviceGroup?: DeviceGroupModel | string;
  /** ISO date-time, start of the first day */
  startDate?: string | null;
  /** ISO date-time, end of the last day */
  endDate?: string | null;
  schedules: PlaylistScheduleSlotModel[];
  createdAt: string;
  updatedAt: string;
}

export interface DeviceGroupScheduleReqModel {
  _id?: string;
  name: string;
  playlist: string;
  startDate?: string;
  endDate?: string;
  schedules: Omit<PlaylistScheduleSlotModel, '_id' | 'playlists'>[];
}
